import { appIntl } from '@nxsys/helpers/Common';
import {
  PaginationType,
} from '@nxsys/types/models/Common';
import { showToast } from '@nxsys/utils/toast';
import { createSlice } from '@reduxjs/toolkit';
import { assignmentActs } from '../action';
import { Assignment, GetAssignmentListParams } from '../types';

export interface AssignmentState {
  assignmentList: {
    loading: boolean;
    list: Assignment[];
    pagination: PaginationType;
    queryParams: GetAssignmentListParams | null;
  };
}

const initialState: AssignmentState = {
  assignmentList: {
    loading: false,
    list: [],
    pagination: {
      current: 1,
      pageSize: 20,
      totalDocs: 0,
    },
    queryParams: null,
  },
};

const assignmentSlice = createSlice({
  name: 'assignment',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Assignment Records
    builder.addCase(assignmentActs.getAssignmentList.pending, (state) => {
      state.assignmentList.loading = true;
    });
    builder.addCase(assignmentActs.getAssignmentList.fulfilled, (state, action) => {
      state.assignmentList.loading = false;
      state.assignmentList.list = action.payload.data;
      state.assignmentList.pagination = action.payload.pagination;
      state.assignmentList.queryParams = (action.payload as any).queryParams;
    });
    builder.addCase(assignmentActs.getAssignmentList.rejected, (state, action) => {
      state.assignmentList.loading = false;
      showToast({
        type: 'error',
        message:
          (action.payload as any)?.response?.data?.message ||
          appIntl().formatMessage({ id: 'assignment.getError' }),
      });
    });

    // Get Assignment
    builder.addCase(assignmentActs.getAssignmentById.pending, () => {
    });
    builder.addCase(assignmentActs.getAssignmentById.fulfilled, () => {
    });
    builder.addCase(assignmentActs.getAssignmentById.rejected, (state, action) => {
      console.info('state', state);
      showToast({
        type: 'error',
        message:
          (action.payload as any)?.response?.data?.message ||
          appIntl().formatMessage({ id: 'assignment.getDetailError' }),
      });
    });

    // Create Assignment
    builder.addCase(assignmentActs.createAssignment.pending, () => {
    });
    builder.addCase(assignmentActs.createAssignment.fulfilled, () => {
      showToast({
        type: 'success',
        message: appIntl().formatMessage({ id: 'assignment.createSuccess' }),
      });
    });
    builder.addCase(assignmentActs.createAssignment.rejected, (state, action) => {
      console.info('state', state);
      showToast({
        type: 'error',
        message:
          (action.payload as any)?.response?.data?.message ||
          appIntl().formatMessage({ id: 'assignment.createError' }),
      });
    });

    // Update Assignment
    builder.addCase(assignmentActs.updateAssignmentById.pending, () => {
    });
    builder.addCase(assignmentActs.updateAssignmentById.fulfilled, () => {
      showToast({
        type: 'success',
        message: appIntl().formatMessage({ id: 'assignment.updateSuccess' }),
      });
    });
    builder.addCase(assignmentActs.updateAssignmentById.rejected, (state, action) => {
      console.info('state', state);
      showToast({
        type: 'error',
        message:
          (action.payload as any)?.response?.data?.message ||
          appIntl().formatMessage({ id: 'assignment.updateError' }),
      });
    });

    // Delete Assignment
    builder.addCase(assignmentActs.deleteAssignmentById.pending, () => {
    });
    builder.addCase(assignmentActs.deleteAssignmentById.fulfilled, () => {
      showToast({
        type: 'success',
        message: appIntl().formatMessage({ id: 'assignment.deleteSuccess' }),
      });
    });
    builder.addCase(assignmentActs.deleteAssignmentById.rejected, (state, action) => {
      console.info('state', state);
      showToast({
        type: 'error',
        message:
          (action.payload as any)?.response?.data?.message ||
          appIntl().formatMessage({ id: 'assignment.deleteError' }),
      });
    });
  },
});

export const assignmentReducer = assignmentSlice.reducer;
export const assignmentActions = {
  ...assignmentSlice.actions,
  ...assignmentActs,
};
